export const environment = {
  production: false,
  apiBaseUrl: 'https://admin-api-dev.kreddypay.com/api',
  // apiBaseUrl: 'http://localhost:3002/api', // Replace with your actual API base URL
};